<template>
    <div>
        <div class="row" style="margin-bottom: 0;">
            <div class="col s12 offset-m2 m8 offset-l3 l6 offset-xl3 xl6">
                <h5 class="center-align white-text">
                    Редактирование камеры: "{{$route.params.name}}" пользователя: "{{$route.params.login}}"
                </h5>
                <h6 v-if="$route.params.type === 'bugs'" class="center-align white-text" style="color: red !important">
                    Внимание это камера созданна автоматически!!! Редактирование крайне не рекомендуется!!!
                </h6>
            </div>
        </div>
        <div class="row">
            <div class="col s12 offset-m2 m8 offset-l2 l8 offset-xl2 xl8">
                <table class="highlight card bg">
                    <tbody>

                    <tr>
                        <td colspan="2" class="row">
                            <div>
                                <a
                                        v-if="$route.params.type !== 'bugs'"
                                        @click="deleteCamera"
                                        style="width: 50px;"
                                        class="btn red darken-3 waves-effect
									    waves-light btn-small col s12 m5 l5 xl5 left">
                                    <i class="material-icons">delete</i>
                                </a>
                                <a @click="$router.push(`/cameras/get/${$route.params.login}/${$route.params.type}`)"
                                   style="width: 50px;"
                                   class="btn grey darken-3 waves-effect
									    waves-light btn-small col s12 m5 l5 xl5 right">
                                    <i class="material-icons">keyboard_backspace</i>
                                </a>
                            </div>
                        </td>
                    </tr>

                    <tr v-if="isCameraWithAgent">
                        <td>Серийный номер</td>
                        <td>
                            {{camera.agent_serial}}
                        </td>
                    </tr>
                    <tr>
                        <td>Глубина архива</td>
                        <td>
                            <div class="input-field col s12 m12 l12 offset-xl2 xl10">
										<textarea id="dvr_depth"
                                                  class="materialize-textarea"
                                                  v-model.number="camera.dvr_depth">
										</textarea>
                                <label for="dvr_depth"></label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Online</td>
                        <td>
                            {{camera.online}}
                        </td>
                    </tr>
                    <tr>
                        <td>Включена</td>
                        <td><label>
                            <input type="checkbox"
                                   v-model="camera.enabled"/>
                            <span></span>
                        </label></td>
                    </tr>
                    <tr>
                        <td>Постоянно работающая</td>
                        <td><label>
                            <input type="checkbox"
                                   v-model="camera.static"/>
                            <span></span>
                        </label></td>
                    </tr>
                    <tr>
                        <td>Частная камера</td>
                        <td>
                            <privatePublicCheckBox v-bind:inputStatus="camera.access"
                                                   @cameraStatus='changeCameraStatus'></privatePublicCheckBox>
                        </td>
                    </tr>
                    <tr v-if="isCameraWithOutAgent">
                        <td>имя</td>
                        <td>
                            {{camera.name}}
                        </td>
                    </tr>
                    <tr>
                        <td>стример</td>
                        <td>
                            {{camera.server}}
                        </td>
                    </tr>
                    <tr v-if="isCameraWithOutAgent">
                        <td>название</td>
                        <td>
                            <div class="input-field col s12 m12 l12 offset-xl2 xl10">
										<textarea id="camera_title"
                                                  class="materialize-textarea"
                                                  v-model="camera.title">
										</textarea>
                                <label for="camera_title"></label>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="isCameraWithOutAgent">
                        <td>Основной URL потока</td>
                        <td>
                            <div class="input-field col s12 m12 l12 offset-xl2 xl10">
										<textarea id="stream_url"
                                                  class="materialize-textarea"
                                                  v-model="camera.stream_url">
										</textarea>
                                <label for="stream_url"></label>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="isCameraWithOutAgent">
                        <td>Дополнительный URL потока</td>
                        <td>
                            <div class="input-field col s12 m12 l12 offset-xl2 xl10">
										<textarea id="substream_url"
                                                  class="materialize-textarea"
                                                  v-model="camera.substream_url">
										</textarea>
                                <label for="substream_url"></label>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="isCameraWithOutAgent">
                        <td>Скриншоты</td>
                        <td><label>
                            <input type="checkbox"
                                   v-model="camera.thumbnails"/>
                            <span></span>
                        </label></td>
                    </tr>
                    <tr v-if="isThumbnailsEnable">
                        <td>URL скриншотов</td>
                        <td>
                            <div class="input-field col s12 m12 l12 offset-xl2 xl10">
										<textarea id="thumbnails_url"
                                                  class="materialize-textarea"
                                                  v-model="camera.thumbnails_url">
										</textarea>
                                <label for="thumbnails_url"></label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="row"
                            colspan="2">
                            <a class="btn red lighten-1 waves-effect waves-light btn-small col s12 m5 l5 xl5"
                               style="margin: 5px 0;"
                               :class="{disabled: isWeBeAbleToDeleteAgent}"
                               @click="deleteAgent">
                                <i class="material-icons left">delete</i>
                                удалить агента
                            </a>
                            <div class="col hide-on-small-only m2 l2 xl2"></div>
                            <a @click="save"
                               style="margin: 5px 0;"
                               :class="{disabled: isWeBeAbleToSaveCamera}"
                               class="btn teal lighten-1 waves-effect
                    waves-light btn-small width-btn col s12 m5 l5 xl5">
                                <i class="material-icons left">save</i>Сохранить</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex";
    import {eventEmitter} from "../../main";
    import setRules from "../../assets/setRules";
    import Cameras from "../../plugins/controllers/cameras";
    import Swal from 'sweetalert2'
    import privatePublicCheckBox from "../../components/custom-inputs/privatePublicCheckBox.vue";

    export default {
        name: "EditCamera",
        data() {
            return {
                camera: {}
            };
        },
        components: {
            privatePublicCheckBox
        },
        methods: {
            deleteAgent() {
                Swal.fire({
                    title: 'Удалить агент на камере?',
                    text: "Камера будет отвязанна от пользователя и заново добавленна в систему с другим ID!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Отмена',
                    confirmButtonText: 'Удалить!'
                }).then((result) => {
                    if (result.value) {
                        Cameras.deleteCameraAgent(this.camera.name).then((response) => {
                            setRules(response);
                            if (response.data.success) {
                                Swal.fire(
                                    'Удалено!',
                                    'Агент удален.',
                                    'success'
                                ).then((result) => {
                                    this.$router.push("/cameras/get/" + this.$route.params.login + "/" + this.$route.params.type);
                                })
                            } else {
                                Swal.fire(
                                    'Не Удалено!',
                                    'Агент не был удален.',
                                    'error'
                                )
                            }
                        }).catch((error) => {
                            Swal.fire(
                                'Не Удалено!',
                                'Возникла ошибка на сервере',
                                'error'
                            )
                        });
                    }
                })
            },
            changeCameraStatus(data) {
                this.camera.access = data;
            },
            save() {
                console.log(this.camera);

                this.updateCamera(this.camera)
            },
            updateCamera(camera) {
                console.log(camera);
                Swal.fire({
                    title: 'Сохранить изменения?',
                    text: "Данные камеры будут изменены!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Отмена',
                    confirmButtonText: 'Сохранить!'
                }).then((result) => {
                    if (result.value) {

                        Cameras.updateCamera(camera).then((response) => {
                            setRules(response);
                            if (response.data.owner === this.$route.params.login) {
                                console.log(response.data);
                                Swal.fire(
                                    'Сохраненно!',
                                    'Камера обновленна.',
                                    'success'
                                ).then((result) => {
                                    this.$router.push("/cameras/get/" + this.$route.params.login + "/" + this.$route.params.type);
                                })
                            }
                        }).catch((error) => {
                            Swal.fire(
                                'Не Сохраненно!',
                                'Возникла ошибка на сервере',
                                'error'
                            )
                        })
                    }
                });
            },
            deleteCamera() {
                console.log("delete");
                console.log(this.camera.name);
                if (this.name !== null) {
                    Swal.fire({
                        title: 'Удалить камеру?',
                        text: "Камера будет удалена навсегда!",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: 'Отмена',
                        confirmButtonText: 'Удалить!'
                    }).then((result) => {
                        if (result.value) {
                            Cameras.deleteCamera(this.camera.name).then((response) => {
                                setRules(response);
                                if (response.data.success) {
                                    Swal.fire(
                                        'Удалено!',
                                        'Камера удалена.',
                                        'success'
                                    ).then((result) => {
                                        this.$router.push("/cameras/get/" + this.$route.params.login + "/" + this.$route.params.type);
                                    })
                                } else {
                                    Swal.fire(
                                        'Не Удалено!',
                                        'Камера не был удалена.',
                                        'error'
                                    )
                                }
                            }).catch((error) => {
                                Swal.fire(
                                    'Не Удалено!',
                                    'Возникла ошибка на сервере',
                                    'error'
                                )
                            });
                        }
                    })
                }
            }
            ,
            getApiData() {
                Cameras.getCameraByName(this.$route.params.name).then((response) => {
                    setRules(response);
                    console.log("response from API");
                    console.log(response.data);
                    this.camera = response.data;
                    if (typeof this.camera.dvr_depth !== "number") {
                        this.camera.dvr_depth = 0;
                    }
                }).catch((error) => {
                    console.log(error)
                })
            }
        }
        ,
        computed: {
            ...
                mapState(["tokenSuccess", "showLargePopup"]),
            isThumbnailsEnable() {
                return (((this.camera.agent_serial === null) || (this.camera.agent_serial === '') ||
                    (typeof this.camera.agent_serial === 'undefined')) && (this.camera.thumbnails === true));
            }
            ,
            isCameraWithAgent() {
                return ((this.camera.agent_serial !== null) && (this.camera.agent_serial !== ''));
            }
            ,
            isCameraWithOutAgent() {
                return ((this.camera.agent_serial === null) || (this.camera.agent_serial === '') ||
                    (typeof this.camera.agent_serial === 'undefined'));
            }
            ,
            isWeBeAbleToSaveCamera() {
                return (((this.camera.agent_serial === null) || (this.camera.agent_serial === '')) &&
                    ((this.camera.name === null) || (this.camera.name === '') ||
                        (this.camera.stream_url === null) || (this.camera.stream_url === '') ||
                        (this.camera.title === null) || (this.camera.title === '')) ||
                    (typeof this.camera.dvr_depth !== "number"))
            }
            ,
            isWeBeAbleToDeleteAgent() {
                return ((this.camera.agent_serial === null) || (this.camera.agent_serial === '') ||
                        (this.camera.online === false) || (this.$route.params.type === 'bugs'));
            }
        },
        beforeMount() {
            eventEmitter.$once("tokenSuccess", this.getApiData);
        },
        beforeDestroy() {
            if (this.e) {
                this.e.forEach(el => {
                    el.destroy();
                });
            }
            eventEmitter.$off("tokenSuccess", this.getApiData);
        },
        mounted() {
            if (this.tokenSuccess) {
                this.getApiData();
            } else {
                console.log("token is not success");
            }
            // preload.show();
        },
        watch: {
            '$route'(to, from) {
                if (this.tokenSuccess) {

                    console.log(localStorage.getItem("login"));
                    console.log(this.$route.params);

                    this.getApiData();

                } else {
                    console.log("token is not success");
                }
            }
            ,
            "camera.thumbnails":

                function (val) {
                    if (val === false) {
                        this.camera.thumbnails_url = "";
                    }
                }
        }
    }
</script>

<style scoped lang="scss">
    .bold {
        font-weight: 500;
    }

    @media screen and (max-width: 600px) {
        h5 {
            font-size: 16px;
            margin-bottom: 0;
        }
    }

    .bg {
        background-color: rgba(56, 56, 56, 0.8);
    }

    input[type="password"] {
        transition: all 0.3s
    }

    input[type="password"].disable {
        visibility: hidden;
    }

    input[type="password"].error {
        color: #c62828;
        border-bottom: 1px solid #c62828;
        box-shadow: 0 1px 0 #c62828;

        &:not(.browser-default):focus:not([readonly]) {
            border-bottom: 1px solid #c62828;
            box-shadow: 0 1px 0 #c62828;
        }

        &:not(.browser-default):focus:not([readonly]) + label {
            color: #c62828;
        }
    }

    textarea, input {

        color: #fff;
        transition: all 0.3s;
    }

    textarea:not(.browser-default):focus:not([readonly]) {
        &:not(.browser-default):focus:not([readonly]) {
            border-bottom: 1px solid #4d5ff1;
            box-shadow: 0 1px 0 #4c5edf;
        }

        &:not(.browser-default):focus:not([readonly]) + label {
            color: #4d5ff1;
        }
    }

    input[type="password"], input[type="text"] {
        &:not(.browser-default):focus:not([readonly]) {
            border-bottom: 1px solid #4d5ff1;
            box-shadow: 0 1px 0 #4c5edf;
        }

        &:not(.browser-default):focus:not([readonly]) + label {
            color: #4d5ff1;
        }
    }

    [type="checkbox"]:checked + span:not(.lever):before {
        border: 2px solid transparent;
        border-right-color: white;
        border-bottom-color: white;
    }

    [type="checkbox"] + span:not(.lever):before {
        border: 2px solid white;
    }

    .parallax-container {
        height: auto;
    }

    table.highlight > tbody > tr > td {
        padding: 7px 10px;
        font-size: 14px;
    }

    table.highlight > tbody > tr > td:first-child {
        padding-left: 12px;
    }

    table.highlight > tbody > tr:hover {
        background-color: rgba(36, 37, 40, 0.51);
    }

    .input-field {
        padding-right: 0;
        margin: 0;
    }

    tr td:first-child {
        width: 20%;
        font-weight: 600;
        text-transform: uppercase;
    }

    tr td:last-child {
        text-align: center;
    }

    .width-btn {
        margin: 10px;
    }
</style>
